module.exports = __webpack_public_path__ + "static/img/about-image1.fe78ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-image1.jpg
// module id = 34
// module chunks = 20